// This changed from w=120 to w=200 as a temporary fix to avoid the thumbnails from being too blurry.
// When backend adds the dimensions of the images stored, we can change this back and calculate the width based on the aspect ratio.
export const thumbnailWidth = 'w=200';
